var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from "vue-property-decorator";
import Typed from 'typed.js';
var AnimatedTitle = /** @class */ (function (_super) {
    __extends(AnimatedTitle, _super);
    function AnimatedTitle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'animated-title';
        _this.typedInstance = null;
        _this.textLines = [];
        _this.paused = false;
        return _this;
    }
    AnimatedTitle.prototype.getTextFromVNode = function (element) {
        var _a;
        // Note: This function only pulls the first elements out, it isn't comprehensive
        // VNode's can be tag-less and simply text
        if (element.text)
            return element.text;
        if ((_a = element.children) === null || _a === void 0 ? void 0 : _a.length) {
            return this.getTextFromVNode(element.children[0]);
        }
        return "";
    };
    AnimatedTitle.prototype.toggle = function () {
        var _a, _b;
        if (this.paused) {
            (_a = this.typedInstance) === null || _a === void 0 ? void 0 : _a.start();
        }
        else {
            (_b = this.typedInstance) === null || _b === void 0 ? void 0 : _b.stop();
        }
        this.paused = !this.paused;
    };
    AnimatedTitle.prototype.mounted = function () {
        var _a;
        // Don't do anything if there's no slots
        if (!this.$refs.titleElement || !((_a = this.$slots) === null || _a === void 0 ? void 0 : _a.default))
            return;
        // Loop over every slot element
        for (var i = 0; i < this.$slots.default.length; i++) {
            var nodeText = this.getTextFromVNode(this.$slots.default[i]);
            // Don't push null/whitespace to the array
            if (!nodeText || nodeText.trim() === "")
                continue;
            this.textLines.push(nodeText);
        }
        // @ts-ignore: elementId can be an element, the type below is incorrect
        this.typedInstance = new Typed(this.$refs.titleElement, {
            strings: this.textLines,
            typeSpeed: 80,
            loop: true,
            backSpeed: 40,
        });
        if (!this.typedInstance)
            return;
        this.typedInstance.start();
    };
    AnimatedTitle = __decorate([
        Component
    ], AnimatedTitle);
    return AnimatedTitle;
}(Vue));
export default AnimatedTitle;
